import { PenTool, Image as ImageIcon, Sparkles, BadgeCheck, Fingerprint, ShieldCheck, Zap } from "lucide-react";
import { Chapter, Reveal } from "./Shared";

const ITEMS = [
  { icon: PenTool, title: "Original Artwork", desc: "Created around your brief", test: "include-original" },
  { icon: ImageIcon, title: "300 DPI PNG", desc: "Transparent background", test: "include-png" },
  { icon: Sparkles, title: "Production Clean Files", desc: "Clean paths, print-safe colors", test: "include-clean" },
  { icon: BadgeCheck, title: "Full Commercial License", desc: "Rights transferred on delivery", test: "include-license" },
  { icon: Fingerprint, title: "Exclusivity Guarantee", desc: "Never resold", test: "include-exclusivity" },
  { icon: ShieldCheck, title: "IP Protection", desc: "US trademark checked before delivery", test: "include-ip" },
  { icon: Zap, title: "Fast Delivery", desc: "Before 8AM EST", test: "include-delivery" },
];

export default function IncludesSection() {
  return (
    <section id="includes" data-testid="includes-section" className="relative">
      <div className="mx-auto max-w-6xl px-6 py-16 sm:py-20">
        <Reveal className="text-center">
          <Chapter num="07" label="In Every File" className="justify-center" />
          <h2 className="mt-6 text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
            What Every Design Includes
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">
          {ITEMS.map((item, i) => (
            <Reveal key={item.test} delay={i * 0.06} className="h-full">
              <div
                data-testid={item.test}
                className="flex h-full flex-col items-center gap-3 rounded-2xl border border-white/10 bg-[#0C1222]/80 p-6 text-center transition-all duration-300 hover:-translate-y-1 hover:border-amber-400/40 hover:shadow-[0_16px_44px_rgba(245,158,11,0.14)]"
              >
                <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-amber-400/30 bg-amber-400/10">
                  <item.icon className="h-5 w-5 text-amber-300" />
                </span>
                <p className="text-sm font-bold leading-snug text-white">{item.title}</p>
                <p className="text-xs leading-snug text-slate-500">{item.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}